// extracted by mini-css-extract-plugin
export default {"truncatedTitle":"kCA2qD","truncatedDescription":"b0WIzI","notes":"WGromu"};